import { render, staticRenderFns } from "./TablePhanTichDienNuocChiTiet.vue?vue&type=template&id=51a72db0&scoped=true"
import script from "./TablePhanTichDienNuocChiTiet.vue?vue&type=script&lang=js"
export * from "./TablePhanTichDienNuocChiTiet.vue?vue&type=script&lang=js"
import style0 from "./TablePhanTichDienNuocChiTiet.vue?vue&type=style&index=0&id=51a72db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a72db0",
  null
  
)

export default component.exports